module.exports = __webpack_public_path__ + "prod/1.42.2/img/cpys_two.2908289e.png";